/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import C4DContentBlock from '../content-block/content-block';
import styles from './content-block-media.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Content block media.
 *
 * @element c4d-content-block-media
 */
@customElement(`${c4dPrefix}-content-block-media`)
class C4DContentBlockMedia extends C4DContentBlock {
  static get stableSelector() {
    return `${c4dPrefix}--content-block-media`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

console.warn(
  'The content-block-media component has been deprecated in favor of the content-section/block and repeated video-player/image components. ' +
    'See content-section/block, video-player, and image documentation for more information.'
);

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentBlockMedia;
